type Constraint = {
  targetEntityUuid: string;
  targetEntityType: "TASK" | "ACTIVITY" | "MILESTONE";
  targetDateType: "END" | "START";
  originEntityUuid: string;
  originEntityType: "TASK" | "ACTIVITY" | "MILESTONE";
  originDateType: "END" | "START";
  constraintType: "EXACTLY" | "AT_MOST" | "AT_LEAST";
  offsetDays: number;
  timeUnit: "DAY" | "HOUR";
};

const constraint: Constraint = {
  targetEntityUuid: "",
  targetEntityType: "TASK",
  targetDateType: "END",
  originEntityUuid: "",
  originEntityType: "TASK",
  originDateType: "END",
  constraintType: "EXACTLY",
  offsetDays: 0,
  timeUnit: "DAY",
};

export type { Constraint };

export { constraint };
